import type { TableId } from '@/components/regionen/pageRegionSlug/mapData/mapDataSources/tables.const'

export type InteracitvityConfiguartion = Record<
  TableId,
  {
    // See `docs/VectorTiles-Minzoom-Maxzoom.md`
    // When zoom < `minzoom` only `stylingKeys` are present
    // When zoom >= `minzoom` all tags are present
    minzoom: number
    // Only those keys will be present
    stylingKeys: string[]
  }
>

export const interactivityConfiguration: InteracitvityConfiguartion = {
  roads: {
    stylingKeys: [
      'road',
      'oneway',
      'oneway_bicycle',
      // 'lit',
      'maxspeed',
      'smoothness',
      // 'surface',
      'bikelane_left',
      'bikelane_right',
      'bikelane_self',
    ],
    minzoom: 9,
  },
  roadsPathClasses: {
    stylingKeys: [
      'road',
      // 'lit',
    ],
    minzoom: 9,
  },
  bikelanesPresence: {
    stylingKeys: ['bikelane_left', 'bikelane_self', 'bikelane_right'],
    minzoom: 0,
  },
  bikeSuitability: {
    stylingKeys: ['bikeSuitability'],
    minzoom: 11,
  },
  bikelanes: {
    stylingKeys: [
      'category',
      // 'lit',
      // 'surface',
      'smoothness',
      'width',
    ],
    minzoom: 9,
  },
  places: {
    stylingKeys: ['place', 'name', 'population'],
    minzoom: 8,
  },
  poiClassification: {
    stylingKeys: ['category', 'name', 'formalEducation', 'amenity'],
    minzoom: 13,
  },
  barrierAreas: { stylingKeys: [], minzoom: 8 },
  highwayAreas: {
    stylingKeys: [
      'road',
      // 'lit',
    ],
    minzoom: 9,
  },
  barrierLines: {
    stylingKeys: ['birdge', 'tunnel', 'railway', 'highway'],
    minzoom: 5,
  },
  bicycleParking_areas: { stylingKeys: ['kind', 'capacity'], minzoom: 9 },
  bicycleParking_points: {
    stylingKeys: ['kind', 'covered', 'capacity'],
    minzoom: 9,
  },
  bikeroutes: {
    stylingKeys: ['network', 'ref', 'cycle_highway'],
    minzoom: 5,
  },
  boundaries: {
    stylingKeys: ['category_municipality', 'category_district', 'name', 'name_prefix'],
    minzoom: 0,
  },
  boundaryLabels: {
    stylingKeys: ['category_municipality', 'name_prefix', 'category_district'],
    minzoom: 0,
  },
  landuse: {
    stylingKeys: ['landuse'],
    minzoom: 9,
  },
  publicTransport: {
    stylingKeys: ['category'],
    minzoom: 11,
  },
  trafficSigns: { stylingKeys: [], minzoom: 0 },
  // aggregated_lengths: { // Does not work, see https://github.com/FixMyBerlin/private-issues/issues/2240
  //   stylingKeys: [],
  //   minzoom: 0,
  // },
  todos_lines: { stylingKeys: [], minzoom: 0 },
  parkings: { stylingKeys: [], minzoom: 0 },
  parkings_edges: {
    stylingKeys: [
      'capacity_left',
      'capacity_right',
      'capacity_private_left',
      'capacity_private_right',
      'operator_type_left',
      'operator_type_right',
      'condition_category_left',
      'condition_category_right',
      'parking_left',
      'parking_right',
      'surface_left',
      'surface_right',
    ],
    minzoom: 14,
  },
  parkings_edges_labels: { stylingKeys: [], minzoom: 0 },
  parkings_labels: { stylingKeys: [], minzoom: 11 },
  parkings_cutouts: { stylingKeys: [], minzoom: 11 },
  parkings_separate: { stylingKeys: [], minzoom: 0 },
  parkings_separate_labels: { stylingKeys: [], minzoom: 0 },
  parkings_no: { stylingKeys: [], minzoom: 0 },
  off_street_parking_areas: { stylingKeys: [], minzoom: 0 },
  off_street_parking_area_labels: { stylingKeys: [], minzoom: 11 },
  off_street_parking_points: { stylingKeys: [], minzoom: 0 },
}
